import { Box, Typography } from '@mui/material';
import { useAuth } from '../contexts/auth-context';

const Footer = () => {
    const { brandingEnabled } = useAuth();
    const showBranding = brandingEnabled !== false;

    return (
        <Box mt={10} py={4} borderTop="1px solid" borderColor="dividerSecondary">
            <Box display='flex' justifyContent='end'>
                {showBranding && (
                    <Typography sx={{ mr: 10 }}>Aquatic Labs</Typography>
                )}
            </Box>
        </Box>
    );
};

export default Footer;
